export const MAX_QUANTITY_PER_LINE = 100;
